module.exports = __webpack_public_path__ + "img/planet.953a078e.png";